import { useEffect, useState } from "react"
import { useNavigate, useParams } from "react-router-dom"
import { ProductMasterForm } from "@univdiam/ui/customComponents/ProductMasterList/ProductMasterForm"
import axios from "axios"

const API_BASE_URL = import.meta.env.VITE_SERVER_URL

export default function EditProductMaster() {
  const [groupData, setGroupData] = useState(null)
  const [subGroupData, setSubGroupData] = useState(null)
  const [subSubGroupData, setSubSubGroupData] = useState(null)
  const [shapeSizeData, setShapeSizeData] = useState(null)
  const [mainCategoryData, setMainCategoryData] = useState(null)
  const [subCategoryData, setSubCategoryData] = useState(null)
  const [collectionData, setCollectionData] = useState(null)
  const { id } = useParams()
  const navigate = useNavigate()
  const [initialData, setInitialData] = useState(null)

  useEffect(() => {
    const fetchProduct = async () => {
      try {
        const response = await axios.get(`${API_BASE_URL}/api/product_masters/${id}`)
        if (response.status === 200 && response.data?.data) {
          const product = response.data.data;
          
          // Transform variants to match our form structure
          const transformedVariants = product.variants?.map(variant => ({
            id: variant.id,
            group: variant.group_name,
            subGroup: variant.sub_group,
            subSubGroup: variant.sub_sub_group,
            shape: variant.shape,
            size: variant.size,
            stones: variant.stones,
            weight: variant.weight,
            // These will be populated later
            availableSubGroups: [],
            availableSubSubGroups: []
          })) || [];
    
          setInitialData({
            design: product.design,
            date: product.date?.split("T")[0],
            customer: product.customer,
            mainCategory: product.main_category,
            subCategory: product.sub_category,
            collection: product.collection,
            cadDoneBy: product.cad_done_by,
            designedBy: product.designed_by,
            finding: product.finding,
            finish: product.finish,
            rhodium: product.rhodium,
            defaultImageTick: product.default_image_tick,
            main_image: product.main_image || "",
            catalog_image: product.catalog_image || "",
            cad_image: product.cad_image || "",
            design_image: product.design_image || "",
            refrence_image: product.refrence_image || "",
            cad_file: product.cad_file || "",
            cad_stl: product.cad_stl || "",
            variants: transformedVariants
          });
    
          console.log("Initial Data:", product);
        }
      } catch (err) {
        console.error("Failed to fetch product master", err);
        alert("Error fetching product.");
        navigate("/product-master");
      }
    }

    fetchProduct()
  }, [id, navigate])

  useEffect(() => {
    const fetchCategory = async () => {
      try {
        const response = await axios.get(`${API_BASE_URL}/api/category`)
        if (response.status === 200 && response.data) {
          const category = response.data.data
          // Map fields to your form shape
          const transformed = category.map((category: any) => ({
            category_id: category.category_id,
            name: category.name,
            status: category.status === 1 ? "Enabled" : "Disabled"
          }))
          setMainCategoryData(transformed)
        }
      } catch (err) {
        console.error("Failed to category", err)
        navigate("/product-master")
      }
    }

    const fetchSubCategory = async () => {
      try {
        const response = await axios.get(`${API_BASE_URL}/api/subcategory`)
        if (response.status === 200 && response.data) {
          const sub_category = response.data.data
          // Map fields to your form shape
          const transformed = sub_category.map((sub_category: any) => ({
            sub_category_id: sub_category.sub_category_id,
            name: sub_category.name,
            status: sub_category.status === 1 ? "Enabled" : "Disabled"
          }))
          setSubCategoryData(transformed)
        }
      } catch (err) {
        console.error("Failed to fetch sub category", err)
        navigate("/product-master")
      }
    }

    const fetchCollection = async () => {
      try {
        const response = await axios.get(`${API_BASE_URL}/api/collection`)
        if (response.status === 200 && response.data) {
          const collection = response.data.data
          // Map fields to your form shape
          const transformed = collection.map((collection: any) => ({
            collection_id: collection.collection_id,
            name: collection.name,
            status: collection.status === 1 ? "Enabled" : "Disabled"
          }))
          setCollectionData(transformed)
        }
      } catch (err) {
        console.error("Failed to fetch sub category", err)
        navigate("/product-master")
      }
    }

    const fetchGroup = async () => {
      try {
        const response = await axios.get(`${API_BASE_URL}/api/product_masters/groups`)
        if (response.status === 200 && response.data) {
          const group = response.data.data
          // Map fields to your form shape
          const transformed = group.map((group: any) => ({
            group_id: group.group_id,
            name: group.name,
            status: group.status === 1 ? "Enabled" : "Disabled"
          }))
          setGroupData(transformed)
        }
      } catch (err) {
        console.error("Failed to fetch group", err)
        navigate("/product-master")
      }
    }

    const fetchSubGroup = async () => {
      try {
        const response = await axios.get(`${API_BASE_URL}/api/sub_groups`)
        if (response.status === 200 && response.data) {
          const group = response.data.data
          // Map fields to your form shape
          const transformed = group.map((group: any) => ({
            sub_group_id: group.sub_group_id,
            name: group.name,
            status: group.status === 1 ? "Enabled" : "Disabled"
          }))
          setSubGroupData(transformed)
        }
      } catch (err) {
        console.error("Failed to fetch sub group", err)
        navigate("/product-master")
      }
    }

    const fetchSubSubGroup = async () => {
      try {
        const response = await axios.get(`${API_BASE_URL}/api/sub_sub_groups`)
        if (response.status === 200 && response.data) {
          const group = response.data.data
          // Map fields to your form shape
          const transformed = group.map((group: any) => ({
            sub_group_id: group.sub_group_id,
            name: group.name,
            status: group.status === 1 ? "Enabled" : "Disabled"
          }))
          setSubSubGroupData(transformed)
        }
      } catch (err) {
        console.error("Failed to fetch sub sub group", err)
        navigate("/product-master")
      }
    }

    const fetchShape = async () => {
      try {
        const response = await axios.get(`${API_BASE_URL}/api/shape_size`)
        if (response.status === 200 && response.data) {
          const shapeSize = response.data.data
          // Map fields to your form shape
          const transformed = shapeSize.map((shapeSize: any) => ({
            shape_size_id: shapeSize.shape_size_id,
            shape: shapeSize.shape,
            status: shapeSize.status === 1 ? "Enabled" : "Disabled"
          }))
          setShapeSizeData(transformed)
        }
      } catch (err) {
        console.error("Failed to fetch Shape Size", err)
        navigate("/product-master")
      }
    }
  
    fetchCategory()
    fetchSubCategory()
    fetchCollection()
    fetchGroup()
    fetchSubGroup()
    fetchSubSubGroup()
    fetchShape()
  }, [])

  const handleUpdateProductMaster = async (data: any) => {
    try {
      const response = await axios.put(`${API_BASE_URL}/api/product_masters/${id}`, data)
      if (response.status === 200) {
        alert("ProductMaster updated successfully!")
        navigate("/product-master")
      }
    } catch (error) {
      console.error("Error updating product master:", error)
      alert("Failed to update product.")
    }
  }

  const handleGroupChange = async (groupId: string) => {
    try {
      const response = await axios.get(`${API_BASE_URL}/api/product_masters/sub_groups/${groupId}`);
      if (response.status === 200) {
        return response.data.data.map((item: any) => ({
          sub_group_id: item.sub_group_id,
          name: item.name,
          status: item.status === 1 ? "Enabled" : "Disabled"
        }));
      }
    } catch (error) {
      console.error("Failed to fetch sub groups:", error);
      return [];
    }
  };

  const handleSubGroupChange = async (subGroupId: string) => {
    try {
      const response = await axios.get(`${API_BASE_URL}/api/product_masters/sub_sub_groups/${subGroupId}`);
      if (response.status === 200) {
        return response.data.data.map((item: any) => ({
          sub_sub_group_id: item.sub_sub_group_id,
          name: item.name,
          status: item.status === 1 ? "Enabled" : "Disabled"
        }));
        // setSubSubGroupData(subSubGroups); // Clear sub-sub-group for now
      }
    } catch (error) {
      console.error("Failed to fetch sub sub groups:", error);
      return [];
    }
  };

  if (!initialData) return <p className="text-center p-10">Loading...</p>

  return (
    <div className="p-6 max-w-5xl mx-auto">
      <h1 className="text-2xl font-bold mb-6">Edit Product Master</h1>
      <ProductMasterForm
        onSubmit={handleUpdateProductMaster}
        initialValues={initialData}
        groupValues={groupData} 
        subGroupValues={subGroupData} 
        subSubGroupValues={subSubGroupData} 
        shapeSizeValues={shapeSizeData} 
        mainCategoryValues={mainCategoryData} 
        subCategoryValues={subCategoryData} 
        collectionValues={collectionData} 
        fetchSubGroups={handleGroupChange}  // Renamed to be more descriptive
        fetchSubSubGroups={handleSubGroupChange} 
        isEdit
      />
    </div>
  )
}
